import { FC } from 'react'
import type { OverlayModalProps } from './types'
import OverlayCarousel from './overlay-carousel'

const OverlayModal: FC<OverlayModalProps> = ({
    images,
    video,
    isOverlayOpen,
    setOverlay,
    initialSlide,
    setSelectedImage,
    footer,
    onOverlayOpen,
    shouldAutoplayVideo = false,
}) => {
    return (
        <OverlayCarousel
            isOverlayOpen={isOverlayOpen}
            setOverlay={setOverlay}
            images={images}
            video={video}
            initialSlide={initialSlide}
            setSelectedImage={setSelectedImage}
            footer={footer}
            onOverlayOpen={onOverlayOpen}
            shouldAutoplayVideo={shouldAutoplayVideo}
        />
    )
}

export default OverlayModal
